<template lang="pug">
  .deprecated
    .value(v-if="!!value")
      p.value(v-if="date") DATE: {{date}}
      p.value(v-if="reason") REASON: {{reason}}
      p.value(v-if="name") {{name}}
      lei-code-link.value.n-a(v-if="lei" :lei="lei")
    p.value.n-a(v-else) not available
    lei-popover(:text="tip", placement="right")
</template>
<script>
import LeiPopover from '@/components/lei-components/LeiPopover'
import LeiCodeLink from './LeiCodeLink'




export default {
  components: {
    LeiPopover,
    LeiCodeLink,
  },
  props: {
    item: {
      type: [ Object, String, ],
      required: true,
    },
  },
  computed: {
    value (){
      return this.item.value ? this.item.value : null
    },
    date () {
      return this.value.date
    },
    reason () {
      return this.value.reason
    },
    name () {
      return this.value.name
    },
    lei () {
      return this.value.lei
    },
    tip () {
      return this.item.text ? this.item.text : 'Not available'
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"

  .deprecated
    display flex
    justify-content: space-between;
    line-height 1.5

</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/DeprecatedBlock.vue